import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { IrregularidadeOperacaoGarantida } from "src/app/model/operacao-irregular.model";
import Utils from "src/app/shared/fgi-utils";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { IrregularidadeService } from "../../irregularidade.service";
import moment from "moment";

@Component({
    selector: 'app-irregularidade-listagem',
    templateUrl: './irregularidade-listagem.component.html',
    styleUrls: ['./irregularidade-listagem.component.scss'],
    standalone: false
})
export class IrregularidadeListagemComponent {
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private opcoesPaginacao: number[] = [10, 15, 20];
  private atributosOrdenacao: EntityOrderedRequestParameters;

  @Input() irregularidades: IrregularidadeOperacaoGarantida[];
  @Input() dataHoraResultado: String;
  @Input() podeCadastrarIrregularidade: boolean;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Output() aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() aoRequererDesativacao: EventEmitter<IrregularidadeOperacaoGarantida> = new EventEmitter<IrregularidadeOperacaoGarantida>();

  constructor(
    private fileUtils: FileUtilsService,
    private service: IrregularidadeService,
    private activatedRoute: ActivatedRoute,) {

    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver
  }

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.irregularidades = this.irregularidades.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.compara(a, b, ord.atributo);
      }
      else {
        return -1 * Utils.compara(a, b, ord.atributo);
      }
    });
  }

  nomeAgenteFinanceiro(id: number) {
    return Utils.nomeAgentePorId(id, this.agentesFinanceiros);
  }

  desativar(irregularidade: IrregularidadeOperacaoGarantida) {
    this.aoRequererDesativacao.emit(irregularidade);
  }
}